import { useEffect, useState } from 'react';
import { AssetTypeItem } from '../../types/fundScreener.type';
import { getFundAssetTypes } from '../../api/fundScreener.api';
import { DEFAULT_ASSET_TYPES } from '../../constants/fundScreener/assetType.constant';

// Fetches the real asset type list for the given market. Returns just
// "All" until the fetch resolves.
export const useFundAssetTypes = (market: string, token: string) => {
  const [assetTypes, setAssetTypes] = useState<AssetTypeItem[]>(DEFAULT_ASSET_TYPES);

  useEffect(() => {
    getFundAssetTypes(market, token)
      .then((items) => {
        setAssetTypes([
          { value: 'ALL', label: 'All', activated: true },
          ...items.map((item) => ({ value: item.id, label: item.label, activated: false })),
        ]);
      })
      .catch((err) => console.error('Failed to fetch fund asset types', err));
  }, [market, token]);

  return assetTypes;
};